import { useCommonStore } from '~/store/common';

export default defineNuxtRouteMiddleware((_, from) => {
  const commonStore = useCommonStore();
  const mobileAppQuery = ['noheader', 'ZW1iZWQ', 'app'];
  const currentView = from?.query?.view?.toString() || '';

  if (mobileAppQuery.includes(currentView)) {
    commonStore.setAppViewMode(true);
  }
});
